<template>
  <v-content class="full-height">
    <v-expansion-panel>
      <v-expansion-panel-content v-for="(item, index) in itens" :key="index">
        <template slot="actions">
          <v-icon color="primary">$vuetify.icons.expand</v-icon>
        </template>
        <template slot="header">
          <h3>{{ item.titulo }}</h3>
        </template>
        <v-card>
          <v-card-text
            class="grey lighten-3"
            v-html="item.conteudo"
          ></v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-content>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "Faq",
  mixins: [ViewMixin],
  data() {
    return {
      itens: [],
    };
  },
  methods: {
    async getFaqList() {
      this.showLoadingIndicator();
      try {
        this.itens = await this.$store.dispatch("GET_FAQ");
      } catch (e) {
        console.warn(e);
      } finally {
        this.hideLoadingIndicator();
      }
    },
  },
  created() {
    this.getFaqList();
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ./src/router/views/Faq/Faq.vue